import dayjs from "dayjs";

export function getRemainingTime(timestampsInMiliseconds) {
  const timestampDayjs = dayjs(timestampsInMiliseconds);
  const nowDayjs = dayjs();

  if (timestampDayjs.isBefore(nowDayjs)) {
    return {
      seconds: "00",
      minutes: "00",
    };
  }

  const seconds = getRemainingSeconds(nowDayjs, timestampDayjs);
  const minutes = getRemainingMinutes(nowDayjs, timestampDayjs);

  return {
    seconds,
    minutes,
  };
}

function getRemainingSeconds(nowDayjs, timestampDayjs) {
  const seconds = timestampDayjs.diff(nowDayjs, "seconds") % 60;
  return formatTime(seconds);
}

function getRemainingMinutes(nowDayjs, timestampDayjs) {
  const minutes = timestampDayjs.diff(nowDayjs, "minutes") % 60;
  return formatTime(minutes);
}

function formatTime(number) {
  const formattedTime = String(number).padStart(2, "0");

  return formattedTime;
}
